import { Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DRIVETRAINS } from "@/rc/drivetrains";
import { RobotDiagram } from "@/components/rc/RobotDiagram";

// Shown when someone closes the wizard before their first setup is saved.
export const EmptySetup = ({ onStart }) => (
  <div className="mx-auto flex max-w-xl flex-col items-center px-4 py-16 text-center" data-testid="empty-setup">
    <div className="rc-card grid grid-cols-3 gap-3">
      {DRIVETRAINS.slice(0, 3).map((dt) => (
        <span key={dt.id} className="flex h-20 w-20 items-center justify-center rounded-2xl border bg-card p-2.5"><RobotDiagram dt={dt} live className="h-full w-full" /></span>
      ))}
    </div>
    <h1 className="mt-8 font-display text-3xl font-extrabold tracking-tight">Set up your robot</h1>
    <p className="mt-3 text-muted-foreground">Tell HubPilot how your robot is built, which ports the motors use and how you want to drive. It takes about a minute.</p>
    <Button size="lg" onClick={onStart} className="mt-8 rounded-full bg-accent px-7 text-accent-foreground hover:bg-accent/90" data-testid="start-setup-button">
      <Wand2 className="mr-1.5 h-4 w-4" />Start setup
    </Button>
  </div>
);
